import SiteBuilderEditorContent from '@/content/package-dash/one-page-site/editor'

export const EMPTY_ADDRESS = {
  address_1: '',
  address_2: '',
  state: '',
  city: '',
  postal_code: '',
  country: '',
}

export const BLANK_LINK = {
  id: '',
  text: '',
  link: '',
  enabled: true,
  icon: 'none',
}

export const DEFAULT_META_DESCRIPTION =
  SiteBuilderEditorContent.metatags.inputs.description.placeholder
